import styled from '@emotion/styled';
import { css } from '@emotion/react';

const Page = styled.main(
    (props) => css`
        display: block;
        margin: 0 auto;
        padding: ${props.theme.spacing['24px']} ${props.theme.spacing['16px']} 0
            ${props.theme.spacing['16px']};

        ${props.theme.mediaQueries.large} {
            max-width: calc(
                ${props.theme.pageWidth}px +
                    (2 * ${props.theme.spacing['32px']})
            );
            padding: ${props.theme.spacing['48px']}
                ${props.theme.spacing['32px']} 0 ${props.theme.spacing['32px']};
        }

        ${props.theme.mediaQueries.extraLarge} {
            max-width: ${props.theme.pageWidth}px;
            padding: 0;
            padding-top: ${props.theme.spacing['48px']};
        }
    `
);

export default Page;
